
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */


try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap-sass');
} catch (e) {}


//lib para conversão de datas

window.moment = require('moment');
window.moment.locale('pt-br');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}



/**
 * Vue Js 2.0
 *
 *
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

window.Vue = Vue;
Vue.use(VueRouter)

import Snotify from 'vue-snotify/vue-snotify.min.js'
// 2. Use Snotify
// You can pass {config, options} as second argument. See the next example or setConfig in [API] section
Vue.use(Snotify)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import money from 'v-money'

// register directive v-money and component <money>
Vue.use(money, {precision: 4})

// Import component
import Loading from 'vue-loading-overlay';

// Init plugin
Vue.use(Loading, {
  color: '#015ed7',
  width: 60,
  height: 60,
  backgroundColor: '#ffffff',
  opacity: 0.5,
  canCancel: false
})

//
import * as uiv from 'uiv'
Vue.use(uiv)


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
